module.exports = __webpack_public_path__ + "media/images/admin/icons/film-6794059390aedb1eb472ccfa95bbdf6f.svg";